import { render, staticRenderFns } from "./ModalConfigEspejo.vue?vue&type=template&id=21fceda8&"
import script from "./ModalConfigEspejo.vue?vue&type=script&lang=js&"
export * from "./ModalConfigEspejo.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfigEspejo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports